import { v4 as uuidv4 } from 'uuid';

import { type IClientProfile } from '../../../types/ClientProfiler';
import * as D from '../deps';
import ClientProfiler from '../lib/ClientProfiler';

interface IClientProfilerEnvironmentOptions {
  filename: string;
  host: string;
  siteKey: string;
}

const logger = D.Logger.child({
  component: 'payments/utils/clientProfiler',
});

const environmentConfigs = {
  staging: {
    host: 'https://staging.cdn-net.com',
    filename: 'cc.js',
    siteKey: '6695153b383c0688',
  },
  prod: {
    host: D.Utils.Environment.getAssetHost(),
    filename: 'p2-collector.js',
    siteKey: '1d69d80c7ae09610',
  },
};

export function getConfig(): IClientProfilerEnvironmentOptions {
  const env: string = D.isProductionUrl() ? 'prod' : 'staging';
  return environmentConfigs[env as keyof typeof environmentConfigs];
}

export function fileLoader(url: string): Promise<void> {
  const TIMEOUT = 0;
  return D.loadFile(url, TIMEOUT);
}

export function generateTransactionId(): string {
  return `p_${uuidv4()}`;
}

export let clientProfiler: ClientProfiler;
try {
  const config = getConfig();
  clientProfiler = new ClientProfiler({
    siteKey: config.siteKey,
    host: config.host,
    filename: config.filename,
    loader: fileLoader,
    generateTransactionId,
    logger: D.Logger.child({
      component: 'payments/lib/ClientProfiler',
    }),
  });
} catch (error) {
  if (error instanceof Error) {
    logger.error(error, 'Failed to instantiate ClientProfiler');
  }
}

export async function initClientProfiler(): Promise<void> {
  try {
    return await clientProfiler.init();
  } catch (error) {
    if (error instanceof Error) {
      logger.error(error, 'Failed to initialize ClientProfiler');
    }
  }
}

export function getClientProfile(): IClientProfile | undefined {
  try {
    return clientProfiler.getClientProfile();
  } catch (error) {
    if (error instanceof Error) {
      logger.error(error, 'Failed to get clientProfile');
    }
  }
}

export function renewClientProfile(): void {
  try {
    return clientProfiler.renew();
  } catch (error) {
    if (error instanceof Error) {
      logger.error(error, 'Failed to renew client profile');
    }
  }
}
